import {Select, Text} from '../1elements'
import FormHelperText from '@mui/material/FormHelperText'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'

const JobTitleSelect = ({disabled, onChange, value, validation, className}) => {
    const [options, setOptions] = useState([])

    const setValue = (value) => {
        onChange(value)
    }

    useEffect(()=>{
      const getContacts = async () => {
        try{
          const res = await ApiService().getAllJobTitles()
          const newOptions = res.data.data.title || []
          setOptions(newOptions)
        }catch(e){
          console.log(e)
        }
      }
      getContacts()
    }, [])

    return(
        <div className={className}>
            <Text type={'fieldLabel'}>Job Title<span className={'requiredAsterisk'}>*</span></Text>
            <Select disabled={disabled} onChange={setValue} options={options} value={value} error={Boolean(validation)}/>
            <FormHelperText error={Boolean(validation)}>{validation}</FormHelperText>
        </div>
    )
}

export default JobTitleSelect
